import networkErrorSvg from "./assets/NetworkError.svg?raw";
import serverErrorSvg from "./assets/ServerError.svg?raw";

const toSvgDataUri = (svg: string) =>
  `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;

export const networkErrorImage = toSvgDataUri(networkErrorSvg);
export const serverErrorImage = toSvgDataUri(serverErrorSvg);
